interface InstagramIconProps {
    color?: string;
    className?: string;
}

function InstagramIcon({ color = 'currentColor', className = null }: InstagramIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="24px"
            height="23px"
            viewBox="0 0 24 23"
            xmlSpace="preserve"
            className={className || undefined}
        >
            <path
                fill={color}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3198 0H6.7193C3.01494 0.0101203 0.0102899 2.96019 0 6.60857V16.0508C0.0154348 19.6942 3.01494 22.6442 6.7193 22.6543H16.3198C20.0241 22.6392 23.0236 19.6891 23.0339 16.0458V6.60351C23.0185 2.96019 20.0138 0.0151806 16.3146 0.00506028H16.3249L16.3198 0ZM17.7602 6.60725C16.9678 6.60725 16.3196 5.97473 16.3196 5.1904C16.3196 4.40608 16.9627 3.77356 17.7602 3.77356C18.5576 3.77356 19.2007 4.40608 19.2007 5.1904C19.2007 5.96967 18.5628 6.60219 17.7653 6.60725H17.7602ZM15.3629 11.3239C15.3629 9.23916 13.6445 7.54906 11.5248 7.54906C9.40506 7.54906 7.68665 9.23916 7.68665 11.3239C7.68665 13.4087 9.40506 15.0988 11.5248 15.0988C13.6445 15.0988 15.3629 13.4087 15.3629 11.3239ZM5.76758 11.3239C5.76758 8.19676 8.3452 5.66162 11.5248 5.66162C14.7044 5.66162 17.282 8.19676 17.282 11.3239C17.282 14.4511 14.7044 16.9863 11.5248 16.9863C8.3452 16.9863 5.76758 14.4511 5.76758 11.3239Z"
            />
        </svg>
    );
}

export default InstagramIcon;
